<h1 matDialogTitle>TFG Voucher Details</h1>

<mat-dialog-content>
  <table style="width: 700px;">
    <tr><td>Voucher</td><td>{{voucher.voucherCode}}</td></tr>
    <!-- <tr><td>Valid</td><td>{{voucher.validVoucher ? 'Yes' : 'No'}}</td></tr> -->
    <!-- <tr><td>Message</td><td>{{voucher.errorMessage}}</td></tr> -->
    <tr><td>Start</td>{{voucher.voucherStart}}<td></td></tr>
    <tr><td>End</td><td>{{voucher.voucherEnd}}</td></tr>
    <!-- <tr><td>Status</td><td>{{voucher.voucherStatus}}</td></tr> -->
    <tr *ngIf="voucher.campaigns && voucher.campaigns.length === 1"><td>Campaign</td><td>{{voucher.campaigns[0].StoreDescription}}</td></tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button matDialogClose>Close</button>
    <button *ngIf="data.canRemoveVoucher" mat-raised-button color="warn" (click)="removeTfgVoucher()">Remove Voucher</button>

</mat-dialog-actions>
